"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAllMessagesRead = exports.sendMessage = exports.getThread = exports.getPreviousMessages = exports.getMessages = exports.getClient = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _conversations = require("@twilio/conversations");
var _angieslistAppPlatform = require("angieslist-app-platform");
var _twilioUrlUtils = require("../../modules/common/utils/twilioUrlUtils");
var _uuid = require("uuid");
var GATEWAY_PREFIX = '/gateway/message-center';
var getThread = exports.getThread = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(spId, userId) {
    return _regenerator["default"].wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", _angieslistAppPlatform.httpClient.get("".concat(GATEWAY_PREFIX, "/v1/messages/thread"), {
            headers: {
              'X-ANGI-CallerId': spId
            },
            params: {
              serviceProviderId: spId,
              userId: userId
            }
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getThread(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var getClient = exports.getClient = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(spId, userId) {
    var res, _res$body, clientToken, channelSid, client;
    return _regenerator["default"].wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 1;
          return getThread(spId, userId);
        case 1:
          res = _context2.sent;
          _res$body = res.body, clientToken = _res$body.clientToken, channelSid = _res$body.channelSid;
          _context2.next = 2;
          return new _conversations.Client(clientToken);
        case 2:
          client = _context2.sent;
          return _context2.abrupt("return", {
            client: client,
            sid: channelSid,
            spId: spId,
            userId: userId
          });
        case 3:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getClient(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

// This service call supports specifying a `pageSize`.  To use the default value,
// simply call the service without the `pageSize` argument
var getMessages = exports.getMessages = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(client, sid) {
    var pageSize,
      conversation,
      twilioMessages,
      modifiedMessages,
      twilioConversationName,
      messages,
      _args3 = arguments;
    return _regenerator["default"].wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          pageSize = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : 30;
          _context3.next = 1;
          return client.getConversationBySid(sid);
        case 1:
          conversation = _context3.sent;
          _context3.next = 2;
          return conversation.getMessages(pageSize);
        case 2:
          twilioMessages = _context3.sent;
          _context3.next = 3;
          return Promise.all((0, _map2["default"])(twilioMessages.items, _twilioUrlUtils.modifyTwilioMessages));
        case 3:
          modifiedMessages = _context3.sent;
          twilioConversationName = conversation.friendlyName;
          messages = {
            messages: modifiedMessages,
            conversationName: twilioConversationName
          };
          return _context3.abrupt("return", messages);
        case 4:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function getMessages(_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();

// This service call supports specifying an `index` and `pageSize`.  To use the default values,
// simply call the service without those parameters, to specify just `pageSize` pass `undefined`
// as the argument for `index`
var getPreviousMessages = exports.getPreviousMessages = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(client, sid, index) {
    var pageSize,
      conversation,
      twilioMessages,
      modifiedMessages,
      _args4 = arguments;
    return _regenerator["default"].wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          pageSize = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : 30;
          _context4.next = 1;
          return client.getConversationBySid(sid);
        case 1:
          conversation = _context4.sent;
          _context4.next = 2;
          return conversation.getMessages(pageSize, index);
        case 2:
          twilioMessages = _context4.sent;
          _context4.next = 3;
          return Promise.all((0, _map2["default"])(twilioMessages.items, _twilioUrlUtils.modifyTwilioMessages));
        case 3:
          modifiedMessages = _context4.sent;
          return _context4.abrupt("return", {
            messages: modifiedMessages
          });
        case 4:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function getPreviousMessages(_x7, _x8, _x9) {
    return _ref4.apply(this, arguments);
  };
}();
var fireMessageAttemptSegmentEvent = function fireMessageAttemptSegmentEvent(messageAttributes, conversationSid, serviceProviderId) {
  _angieslistAppPlatform.tracker.track('Twilio Conversation Message Attempted', {
    messageUuid: messageAttributes.MessageUUID,
    trackingSource: messageAttributes.TrackingSource,
    conversationSid: conversationSid,
    author: "al_".concat(serviceProviderId),
    messageType: messageAttributes.MessageType
  });
};
var getMessageAttributes = function getMessageAttributes(browser, message) {
  var isMobile = browser.lessThan.sm;
  var isTablet = browser.lessThan.lg && !isMobile;
  var hasMedia = message instanceof FormData;
  var trackingSource;
  if (isMobile) {
    trackingSource = 'angi_pro_lead_ion_mobile';
  } else if (isTablet) {
    trackingSource = 'angi_pro_lead_ion_tablet';
  } else {
    trackingSource = 'angi_pro_lead_ion_desktop';
  }
  return {
    MessageSource: isMobile ? 'MOBILE_WEB' : 'DESKTOP',
    MessageType: hasMedia ? 'MEDIA' : 'TEXT',
    MessageUUID: (0, _uuid.v4)(),
    TrackingSource: "".concat(trackingSource)
  };
};
var sendMessage = exports.sendMessage = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(client, conversationSid, message, serviceProviderId, browser) {
    var messageAttributes, conversation;
    return _regenerator["default"].wrap(function (_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          messageAttributes = getMessageAttributes(browser, message);
          fireMessageAttemptSegmentEvent(messageAttributes, conversationSid, serviceProviderId);
          _context5.next = 1;
          return client.getConversationBySid(conversationSid);
        case 1:
          conversation = _context5.sent;
          _context5.next = 2;
          return conversation.sendMessage(message, messageAttributes);
        case 2:
          return _context5.abrupt("return", _context5.sent);
        case 3:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function sendMessage(_x0, _x1, _x10, _x11, _x12) {
    return _ref5.apply(this, arguments);
  };
}();
var setAllMessagesRead = exports.setAllMessagesRead = /*#__PURE__*/function () {
  var _ref6 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(client, sid) {
    var conversation, unreadCount;
    return _regenerator["default"].wrap(function (_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 1;
          return client.getConversationBySid(sid);
        case 1:
          conversation = _context6.sent;
          _context6.next = 2;
          return conversation.setAllMessagesRead();
        case 2:
          unreadCount = _context6.sent;
          return _context6.abrupt("return", unreadCount);
        case 3:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function setAllMessagesRead(_x13, _x14) {
    return _ref6.apply(this, arguments);
  };
}();


//////////////////
// WEBPACK FOOTER
// ./node_modules/lead-ion/lib/common/services/twilioServices.js
// module id = 2355
// module chunks = 25